import TextFormGroup from "./TextFormGroup";

export default TextFormGroup;


// WEBPACK FOOTER //
// ./src/common/components/textFormGroup/index.js